<div id="portada-lineas-inversion" class="py-5 px-lg-5">
  @if (plataformaId === 'SEGOFINANCE') {
    <div class="container">
      <h1 class="primary-900 text-center mb-3">Nuestros productos</h1>
      <div class="row d-none d-lg-flex mb-3">
        <div class="col-12">
          <div
            class="select-productos border-1 border-primary-400 border-radius-50 d-flex justify-content-center p-1">
            <button class="btn btn-tipo-producto font-weight-600 border-0 border-radius-50 w-100"
              [ngClass]="{'active': selectedProducto === 'cnmv'}"
              (click)="selectedProducto = 'cnmv'; seleccionarLinea('venture')"
              title="Financiación Participativa">
              Financiación Participativa
            </button>
            <button class="btn btn-tipo-producto font-weight-600 border-0 border-radius-50 w-100"
              [ngClass]="{'active': selectedProducto === 'otros'}"
              (click)="selectedProducto = 'otros';  seleccionarLinea('factoring')"
              title="Otros Productos">
              Otros Productos
            </button>
          </div>
        </div>
      </div>
      @if (selectedProducto === 'cnmv') {
        <div class="row fadein">
          <div class="col-lg-4">
            <app-select-linea [isActive]="lineaActiva == 'segoVenturesInfo' ? true : false"
              [info]="componentInfo['segoVenturesInfo']"
            (click)="seleccionarLinea('segoVenturesInfo')"></app-select-linea>
          </div>
          <div class="col-lg-4">
            <app-select-linea [isActive]="lineaActiva == 'segoRealEstateInfo' ? true : false"
              [info]="componentInfo['segoRealEstateInfo']"
            (click)="seleccionarLinea('segoRealEstateInfo')"></app-select-linea>
          </div>
          <div class="col-lg-4">
            <app-select-linea [isActive]="lineaActiva == 'segoCreativeInfo' ? true : false"
              [info]="componentInfo['segoCreativeInfo']"
            (click)="seleccionarLinea('segoCreativeInfo')"></app-select-linea>
          </div>
        </div>
      }
      @if (selectedProducto === 'otros') {
        <div class="row fadein">
          <div class="col-lg-6">
            <app-select-linea [isActive]="lineaActiva == 'segoFactoringInfo' ? true : false"
              [info]="componentInfo['segoFactoringInfo']"
            (click)="seleccionarLinea('segoFactoringInfo')"></app-select-linea>
          </div>
          <div class="col-lg-6">
            <app-select-linea [isActive]="lineaActiva == 'segoFundsInfo' ? true : false"
              [info]="componentInfo['segoFundsInfo']"
            (click)="seleccionarLinea('segoFundsInfo')"></app-select-linea>
          </div>
        </div>
      }
      <div class="row">
        <div class="col-12">
          <div class="d-block d-lg-none">
            <p class="p1-medium text-center mb-4">Selecciona el producto que mejor te encaje</p>
            <div id="position-linea-select" [ngClass]="{'isLogged': isLogged}" class="min-width-257">
              @if (lineaActiva) {
                <app-select-linea-mobile [infoLineaActiva]="componentInfo[lineaActiva]"
                  [infoLineas]="infoLineas"
                (seleccionarLineaMobile)="seleccionarLinea($event)"></app-select-linea-mobile>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
    @if (lineaActiva) {
      <div class="container-fluid fadein">
        <div class="row">
          <div id="portada-linea-content" class="col-12 pt-4 mt-1 mt-lg-3 px-0">
            @if (componentInfo[lineaActiva].ref === 'venture') {
              <app-home-venture
              class="fadeinMenu"></app-home-venture>
            }
            @if (componentInfo[lineaActiva].ref === 'realestate') {
              <app-home-realestate
              class="fadeinMenu"></app-home-realestate>
            }
            @if (componentInfo[lineaActiva].ref === 'creative') {
              <app-home-creative
              class="fadeinMenu"></app-home-creative>
            }
            @if (componentInfo[lineaActiva].ref === 'factoring') {
              <app-home-factoring
              class="fadeinMenu"></app-home-factoring>
            }
            @if (componentInfo[lineaActiva].ref === 'funds') {
              <app-home-funds
              class="fadeinMenu"></app-home-funds>
            }
          </div>
        </div>
      </div>
    }
  }

  @if (plataformaId === 'VENTURE' || plataformaId === 'REALESTATE' || plataformaId === 'CREATIVE') {
    <div class="container">
      <div class="row">
          <app-select-linea class="col-lg-4 flexbox" [isActive]="lineaActiva == 'segoVenturesInfo' ? true : false"
            [info]="componentInfo['segoVenturesInfo']"
          (click)="seleccionarLinea('segoVenturesInfo')"></app-select-linea>
          <app-select-linea class="col-lg-4 flexbox" [isActive]="lineaActiva == 'segoRealEstateInfo' ? true : false"
            [info]="componentInfo['segoRealEstateInfo']"
          (click)="seleccionarLinea('segoRealEstateInfo')"></app-select-linea>
          <app-select-linea class="col-lg-4 flexbox" [isActive]="lineaActiva == 'segoCreativeInfo' ? true : false"
            [info]="componentInfo['segoCreativeInfo']"
          (click)="seleccionarLinea('segoCreativeInfo')"></app-select-linea>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="d-block d-lg-none">
            <div id="position-linea-select" [ngClass]="{'isLogged': isLogged}" class="min-width-257">
              @if (lineaActiva) {
                <app-select-linea-mobile [infoLineaActiva]="componentInfo[lineaActiva]"
                  [infoLineas]="infoLineas" [isRouteCnmv]="true"
                (seleccionarLineaMobile)="seleccionarLinea($event)"></app-select-linea-mobile>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
    @if (lineaActiva) {
      <div class="container-fluid fadein">
        <div class="row">
          <div id="portada-linea-content" class="col-12 pt-4 pt-lg-5 px-0">
            @if (componentInfo[lineaActiva].ref === 'venture') {
              <app-home-venture
              class="fadeinMenu"></app-home-venture>
            }
            @if (componentInfo[lineaActiva].ref === 'realestate') {
              <app-home-realestate
              class="fadeinMenu"></app-home-realestate>
            }
            @if (componentInfo[lineaActiva].ref === 'creative') {
              <app-home-creative
              class="fadeinMenu"></app-home-creative>
            }
          </div>
        </div>
      </div>
    }
  }
</div>